/* Rorilio · PDP Rímel con sérum : galerie, packs + couleur par tube, sérum en option, date de livraison, carrousels, compteurs, onglets. */
(() => {
  if (window.RorilioRimelPDP) return;
  window.RorilioRimelPDP = true;

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    const track = root.querySelector('[data-rpr-track]');
    if (!track) return;
    const slides = [...track.children];
    const thumbs = [...root.querySelectorAll('[data-rpr-thumb]')];
    const bar = root.querySelector('[data-rpr-bar]');
    let current = 0;
    const go = (i) => {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    };
    const mark = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      current = Math.min(slides.length - 1, Math.max(0, i));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === current));
      const active = thumbs[current];
      if (active) {
        const strip = active.parentElement;
        const l = active.offsetLeft - strip.offsetLeft, r = l + active.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
      }
      if (bar) {
        bar.style.width = (100 / slides.length) + '%';
        bar.style.transform = 'translateX(' + (current * 100) + '%)';
      }
    };
    root.querySelector('[data-rpr-prev]')?.addEventListener('click', () => go(current - 1));
    root.querySelector('[data-rpr-next]')?.addEventListener('click', () => go(current + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.rprThumb))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    mark();
  }

  /* ---------- Offre (packs, couleurs, sérum) ---------- */
  function initOffer(root) {
    const offer = root.querySelector('[data-rpr-offer]');
    const form = document.getElementById(root.dataset.formId);
    const dataEl = root.querySelector('[data-rpr-variants]');
    if (!offer || !form || !dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const colors = (root.dataset.colors || '').split(',').map((c) => c.trim()).filter(Boolean);
    const idInput = form.querySelector('[data-rpr-variant-id]');
    const atc = form.querySelector('[data-rpr-atc]');
    const status = root.querySelector('[data-rpr-status]');
    const cards = [...offer.querySelectorAll('[data-rpr-pack]')];

    const mixOf = (values) => {
      const counts = colors.map((c) => values.filter((v) => v === c).length);
      return colors.map((c, i) => (counts[i] ? counts[i] + ' ' + c : '')).filter(Boolean).join(' + ');
    };
    const colorsFromMix = (mix) => {
      const out = [];
      (mix || '').split(' + ').forEach((part) => {
        const m = part.match(/^(\d+)\s+(.+)$/);
        if (m) for (let i = 0; i < Number(m[1]); i++) out.push(m[2]);
      });
      return out;
    };

    // Couleurs initiales (variante passée dans l'URL ou défaut)
    const initial = colorsFromMix(root.dataset.initialMix);
    const selected = cards.find((c) => c.querySelector('input[type=radio]').checked);
    if (selected && initial.length) {
      selected.querySelectorAll('select[data-rpr-tube]').forEach((s, i) => { if (initial[i]) s.value = initial[i]; });
    }

    const sync = () => {
      const active = cards.find((c) => c.querySelector('input[type=radio]').checked) || cards[0];
      cards.forEach((card) => {
        const on = card === active;
        card.classList.toggle('is-selected', on);
        const tubes = card.querySelector('[data-rpr-tubes]');
        if (tubes) tubes.hidden = !on;
        card.querySelectorAll('select').forEach((s) => { s.disabled = !on; });
      });
      const units = Number(active.dataset.rprPack);
      const values = [...active.querySelectorAll('select[data-rpr-tube]')].map((s) => s.value);
      const mix = mixOf(values);
      const match = variants.find((v) => v.units === units && v.mix === mix);
      idInput.value = match ? String(match.id) : '';
      const ok = !!(match && match.available);
      atc.disabled = !ok;
      if (ok) atc.removeAttribute('aria-disabled');
      atc.querySelector('[data-rpr-atc-label]').textContent = ok ? atc.dataset.label : atc.dataset.unavailable;
      atc.querySelector('[data-rpr-atc-price]').textContent = match ? match.price : active.dataset.price;
      atc.querySelector('[data-rpr-atc-compare]').textContent = match ? match.compare : active.dataset.compare;
      if (status) status.textContent = (match ? match.pack + ' · ' + values.join(', ') + ' · ' + match.price : atc.dataset.unavailable);
      return match;
    };

    offer.addEventListener('change', sync);

    // Sérum coché : on l'ajoute d'abord au panier, puis le formulaire Dawn ajoute le pack et ouvre le tiroir panier.
    const upsell = offer.querySelector('[data-rpr-upsell]');
    let upsellDone = false;
    // Tubes : 2 lignes du produit caché « 1 tube » (moitié des tubes chacune, couleurs en propriété, _grupo pour ne jamais fusionner) ;
    // la remise automatique 1 + 1 rend une ligne gratuite. Sans produit caché, ancien ajout du pack.
    const unitEl = root.querySelector('[data-rpr-unit]');
    const unit = unitEl ? JSON.parse(unitEl.textContent) : null;
    const cartDrawer = document.querySelector('cart-drawer');
    form.addEventListener('submit', async (e) => {
      const match = sync();
      if (!match || !match.available) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (unit) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const active = cards.find((c) => c.querySelector('input[type=radio]').checked) || cards[0];
        if (!unit.available) return;
        const colorsOf = [...active.querySelectorAll('select[data-rpr-tube]')].map((s) => s.value);
        const half = colorsOf.length / 2;
        const stamp = Date.now().toString(36);
        const line = (cols, n) => ({ id: unit.id, quantity: cols.length, properties: { [cols.length > 1 ? 'Colores' : 'Color']: cols.join(', '), _grupo: stamp + '-' + n } });
        // Le panier affiche le dernier ajout en premier : sérum, tubes 1..n/2, puis tubes offerts (n/2+1..n).
        const items = [line(colorsOf.slice(0, half), 1), line(colorsOf.slice(half), 2)];
        if (upsell && upsell.checked) items.unshift({ id: Number(upsell.dataset.rprUpsell), quantity: 1 });
        const body = { items };
        if (cartDrawer) { body.sections = cartDrawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
        atc.setAttribute('aria-disabled', 'true');
        atc.classList.add('loading');
        try {
          const r = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const res = await r.json();
          if (!r.ok) throw new Error(res.description || res.message || r.status);
          if (cartDrawer) { cartDrawer.classList.remove('is-empty'); cartDrawer.renderContents(res); } else window.location.href = window.routes?.cart_url || '/cart';
        } catch (err) {
          console.warn('Rorilio: tubos no añadidos', err);
          if (status) status.textContent = String(err.message || err);
        }
        atc.classList.remove('loading');
        atc.removeAttribute('aria-disabled');
        return;
      }
      if (!upsell || !upsell.checked || upsellDone) { upsellDone = false; return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      atc.setAttribute('aria-disabled', 'true');
      atc.classList.add('loading');
      try {
        const r = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(upsell.dataset.rprUpsell), quantity: 1 }] }),
        });
        if (!r.ok) console.warn('Rorilio: sérum no añadido', r.status);
      } catch (err) {
        console.warn('Rorilio: sérum no añadido', err);
      }
      atc.classList.remove('loading');
      atc.removeAttribute('aria-disabled');
      upsellDone = true;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }, true);

    sync();
  }

  /* ---------- Date de livraison ---------- */
  function initDelivery(root) {
    root.querySelectorAll('[data-rpr-delivery]').forEach((el) => {
      const days = Number(el.dataset.days) || 9;
      const d = new Date();
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      let label;
      try { label = d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' }); }
      catch (e) { label = d.toDateString(); }
      el.querySelector('[data-rpr-delivery-text]').textContent = (el.dataset.template || '').replace('[fecha]', label);
    });
  }

  /* ---------- Carrousels avec barre ---------- */
  function initScrollers(scope) {
    scope.querySelectorAll('[data-rpr-scroller]').forEach((box) => {
      const track = box.querySelector('[data-rpr-scroll-track]');
      const bar = box.querySelector('[data-rpr-scroll-bar]');
      if (!track || !bar) return;
      const upd = () => {
        const ratio = track.clientWidth / Math.max(track.scrollWidth, 1);
        bar.style.width = Math.min(100, ratio * 100) + '%';
        const max = track.scrollWidth - track.clientWidth;
        const p = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (1 / Math.max(ratio, 0.01) - 1) * 100) + '%)';
      };
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- Compteurs ---------- */
  function initCounters(scope) {
    const els = [...scope.querySelectorAll('[data-rpr-count]')];
    if (!els.length) return;
    const run = (el) => {
      const target = Number(el.dataset.rprCount) || 0;
      const start = performance.now();
      const step = (t) => {
        const k = Math.min(1, (t - start) / 1400);
        el.textContent = String(Math.round(target * (1 - Math.pow(1 - k, 3))));
        if (k < 1) requestAnimationFrame(step);
      };
      el.textContent = '0';
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Onglets chronologie ---------- */
  function initTabs(scope) {
    scope.querySelectorAll('[data-rpr-tabs]').forEach((box) => {
      const tabs = [...box.querySelectorAll('[data-rpr-tab]')];
      const panes = [...box.querySelectorAll('[data-rpr-pane]')];
      const show = (i) => {
        tabs.forEach((t, n) => { t.classList.toggle('is-active', n === i); t.setAttribute('aria-selected', String(n === i)); });
        panes.forEach((p, n) => { p.hidden = n !== i; });
      };
      tabs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-rpr-main]').forEach((root) => {
      if (root.dataset.rprReady) return;
      root.dataset.rprReady = '1';
      root.querySelectorAll('[data-rpr-gallery]').forEach(initGallery);
      initOffer(root);
      initDelivery(root);
    });
    initScrollers(scope);
    initCounters(scope);
    initTabs(scope);
  }

  const boot = () => initAll(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
